module.exports = __webpack_public_path__ + "static/img/案例7.29a56b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/案例7.jpg
// module id = 7KcW
// module chunks = 1